import React, { Component, createRef } from "react";
// // Editable
// import { BootstrapTable,TableHeaderColumn } from "react-bootstrap-table";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import validate from "../../common/validation";

import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { categoriTypes } from "../StaticData.js";
import { Link } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  addDataEntryStock,
  getUserByRoleId,
  getUserApi,
  updateDataEntryStock,
  dataEntryOutWardStocks,
  addSalesOfficeOutWardStocks,
} from "../../api";
import { withTranslation } from "react-i18next";
import ShowDiffenence from "components/Common/ShowDiffenence";

class UserOutwardStock extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      editRowIndex: -1,
      props: props?.location?.query
        ? props.location.query
        : {
            isEdit: 1,
            data: null,
          },
      graderList: [],
      notEditableRows:
        props.location.query.isEdit == 1
          ? [1, 2, 3, 4]
          : props?.location?.query?.data?.graderStock.stockGraderInWards.map(
              x => x.id
            ),
      stockList:
        props.location.query.isEdit == 1
          ? [
              {
                id: 1,
                srNo: 1,
                weight: 0,
                weightType: "CT",
                pieces: 0,
                remarks: "",
                nextRemarks: "",
              },
              {
                id: 2,
                srNo: 2,
                weight: 0,
                weightType: "CT",
                pieces: 0,
                remarks: "",
                nextRemarks: "",
              },
              {
                id: 3,
                srNo: 3,
                weight: 0,
                weightType: "CT",
                pieces: 0,
                remarks: "",
                nextRemarks: "",
              },
              {
                id: 4,
                srNo: 4,
                weight: 0,
                weightType: "CT",
                pieces: 0,
                remarks: "",
                nextRemarks: "",
              },
            ]
          : props?.location?.query.data.graderStock.stockGraderInWards,
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async componentDidMount() {
    const grader = await getUserApi({
      factoryId: this.state.props.data.jangad.factoryId,
      roleId: "ROLE0000007",
    });
    if (grader && grader.data) {
      this.setState({
        graderList: grader.data.users,
      });
    }
  }

  deleteRow(rowIndex) {
    this.state.stockList.splice(rowIndex, 1);
    this.setState({
      stockList: this.state.stockList,
      notEditableRows: this.state.stockList.map((x, index) => x.id),
    });
  }
  addRow() {
    this.setState({
      stockList: [
        ...this.state.stockList,
        {
          id: this.state.stockList.length + 1,
          srNo: this.state.stockList.length + 1,
          categoryId: 1,
          weight: 0,
          weightType: "CT",
          pieces: 0,
          remarks: "",
          nextRemarks: "",
        },
      ],
      notEditableRows: [
        ...this.state.notEditableRows,
        this.state.stockList.length + 1,
      ],
    });
  }
  handleSubmit = async values => {
    if (this.state.props.isEdit == 2) {
      let temp = {
        nextRemarks: values.nextRemarks,
        mainJangadId: this.state.props.data.mainJangadId,
        jangadId: this.state.props.data.jangadId,
        dataEntryStockId: this.state.props.data.id,
        graderStockId: this.state.props.data.graderStockId,
        graderOutWardStockId: this.state.props.data.id,
      };
      const data = await dataEntryOutWardStocks(temp);
    }
  };

  assign = async values => {
    let temp = {
      nextRemarks: values.nextRemarks,
      mainJangadId: this.state.props.data.mainJangadId,
      jangadId: this.state.props.data.jangadId,
      dataEntryStockId: this.state.props.data.dataEntryStockId,
      graderStockId: this.state.props.data.graderStockId,
      graderOutWardStockId: this.state.props.data.graderOutWardStockId,
      dataEntryOutWardStockId: this.state.props.data.id,
    };
    const data = await addSalesOfficeOutWardStocks(temp);
    this.props.history.goBack();
  };

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    const defaultSorted = [
      {
        dataField: "srNo",
        order: "asc",
      },
    ];
    document.title = "data entry person";
    //meta title
    this.columns1 = [
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: "",
        sort: true,
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        footer: "",
        sort: true,
        formatter: (cell, row, rowIndex) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        type: "number",
        footer: "",
        formatter: (cell, row, rowIndex) => {
          return row.stockDataEntryInWard.pieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "weight", newValue, row, column),
      },
      {
        dataField: "outWardWeight",
        text: `${this.props.t("Outward Weight")}`,
        footer: "",
        type: "number",
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
      },

      {
        dataField: "remarks",
        text: `${this.props.t("Self Internal Remarks")}`,
        footer: "",
        formatter: (cell, row, rowIndex) => {
          return row.stockDataEntryInWard.nextRemarks;
        },
      },
      {
        dataField: "nextRemarks",
        text: `${this.props.t("For Next Person Instruction")}`,
        footer: "",
      },
      // {
      //   dataField: "edit",
      //   text: `${this.props.t("Edit Data")}`,
      //   footer: "",
      //   editable: true,

      //   editorRenderer: (
      //     editorProps,
      //     value,
      //     row,
      //     column,
      //     rowIndex,
      //     columnIndex
      //   ) => {
      //     return (
      //       <div className="btn-group">
      //         {!this.state.notEditableRows.includes(row.id) ? (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               this.setState({
      //                 notEditableRows: [...this.state.notEditableRows, row.id],
      //               });
      //             }}
      //           >
      //             <img src="images/dashboard-images/print.svg"></img>
      //           </span>
      //         ) : (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               if (
      //                 this.state.notEditableRows.length ===
      //                 this.state.stockList.length
      //               )
      //                 this.setState({
      //                   notEditableRows: this.state.notEditableRows.filter(
      //                     x => x != row.id
      //                   ),
      //                 });
      //             }}
      //           >
      //             <img src="images/dashboard-images/edit.svg"></img>
      //           </span>
      //         )}
      //         <button
      //           className="bg-transparent border-0 ms-3"
      //           onClick={() => this.deleteRow(rowIndex)}
      //         >
      //           <img src="images/dashboard-images/deleteRow.svg"></img>
      //         </button>
      //       </div>
      //     );
      //   },
      //   formatter: (cell, row, rowIndex) => (
      //     <div className="btn-group">
      //       {!this.state.notEditableRows.includes(row.id) ? (
      //         <span
      //           className="border-0 rounded ms-2"
      //           onClick={() => {
      //             this.setState({
      //               notEditableRows: [...this.state.notEditableRows, row.id],
      //             });
      //           }}
      //         >
      //           <img src="images/dashboard-images/print.svg"></img>
      //         </span>
      //       ) : (
      //         <span
      //           className="border-0 rounded ms-2"
      //           onClick={() => {
      //             if (
      //               this.state.notEditableRows.length ===
      //               this.state.stockList.length
      //             )
      //               this.setState({
      //                 notEditableRows: this.state.notEditableRows.filter(
      //                   x => x != row.id
      //                 ),
      //               });
      //           }}
      //         >
      //           <img src="images/dashboard-images/edit.svg"></img>
      //         </span>
      //       )}
      //       <button
      //         className="bg-transparent border-0 ms-3"
      //         onClick={() => this.deleteRow(rowIndex)}
      //       >
      //         <img src="images/dashboard-images/deleteRow.svg"></img>
      //       </button>
      //     </div>
      //   ),
      // },
    ];

    document.title = "data-entry flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={`${this.props.t("MANAGE STOCK - INWARD")}`}
            />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={
                  this.state.props.isEdit == 1
                    ? {
                        id: this.state.props.data.mainJangadId,
                        name: this.state.props.data.mainJangad.name,
                        partyName: this.state.props.data.mainJangad.party.name,
                        partyJangadNo:
                          this.state.props.data.mainJangad.partyJangadNo,
                        unitName: this.state.props.data.factory.id,
                        category:
                          this.state.props.data.mainJangad.category.name,
                        weight: this.state.props.data.weight,
                        pieces: this.state.props.data.pieces,
                        salesOfficeUserId: "",
                        remarks: this.state.props.data.remarks,
                        nextRemarks: "",
                      }
                    : {
                        id: this.state.props.data.mainJangadId,
                        name: this.state.props.data.mainJangad.name,
                        partyName: this.state.props.data.mainJangad.party.name,
                        partyJangadNo:
                          this.state.props.data.mainJangad.partyJangadNo,
                        unitName: this.state.props.data.jangad.factory.name,
                        weight: this.state.props.data.jangad.weight,
                        dataEntryPersonName: this.state.props.data.user.name,
                        graderUserName:
                          this.state.props.data.graderOutWardStock.user.name,
                        category:
                          this.state.props.data.mainJangad.category.name,
                        pieces: this.state.props.data.jangad.pieces,
                        nextRemarks: "",
                        // remarks: this.state.props.data.remarks,
                        // nextRemarks: this.state.props.data.nextRemarks,
                      }
                }
                validationSchema={Yup.object().shape({
                  id: Yup.string().required("This value is required"),
                  partyName: Yup.string().required("This value is required"),
                  partyJangadNo: Yup.string().required(
                    "This value is required"
                  ),
                  unitName: Yup.string().required("This value is required"),
                  weight: Yup.string().required("This value is required"),
                  pieces: Yup.string().required("This value is required"),
                  remarks: Yup.string().max(512).notRequired(),
                  nextremarks: Yup.string().max(512).notRequired(),
                })}
                onSubmit={values => {}}
              >
                {({
                  errors,
                  status,
                  touched,
                  values,
                  submitCount,
                  validateForm,
                }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            {this.state.props.isEdit == 1 && (
                              <h4 className="text-black fw-bold mb-4">
                                {this.props.t("Add New Stock (Inward)")}
                              </h4>
                            )}
                            {this.state.props.isEdit == 2 && (
                              <h4 className="text-black fw-bold mb-4">
                                {this.props.t("Edit Stock (Inward)")}
                              </h4>
                            )}
                            {this.state.props.isEdit == 3 && (
                              <h4 className="text-black fw-bold mb-4">
                                View Stock (Inward)
                              </h4>
                            )}
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>
                        <div className="col-xl-8 col-12">
                          <CardBody>
                            <Row>
                              {/* <div className="mb-3 row">
                                <Label
                                  htmlFor="id"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Jangad Id")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.id && touched.id
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="id"
                                    placeholder="JANGAD0000123"
                                  />
                                  <ErrorMessage
                                    name="id"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div> */}
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="name"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Jangad Id")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.name && touched.name
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="name"
                                    placeholder="JANGAD0000123"
                                  />
                                  <ErrorMessage
                                    name="name"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="partyName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Party Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.partyName && touched.partyName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="partyName"
                                    placeholder="XYZ Diamond"
                                  />
                                  <ErrorMessage
                                    name="partyName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="partyJangadNo"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Party Jangad No.")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.partyJangadNo &&
                                      touched.partyJangadNo
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="partyJangadNo"
                                    placeholder="566464"
                                  />
                                  <ErrorMessage
                                    name="partyJangadNo"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="unitName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Unit Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.unitName && touched.unitName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="unitName"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="unitName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="category"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Diamond Category")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.category && touched.category
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="category"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="category"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="dataEntryPersonName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Data Entry Person Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.dataEntryPersonName &&
                                      touched.dataEntryPersonName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="dataEntryPersonName"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="dataEntryPersonName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="graderUserName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Grader Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.graderUserName &&
                                      touched.graderUserName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    name="graderUserName"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="graderUserName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="pieces"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Total No of Pieces")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.pieces && touched.pieces
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    type="text"
                                    value={(() => {
                                      if (this.state.props.isEdit == 1) {
                                        return this.state.props.data.pieces;
                                      } else {
                                        return ShowDiffenence(
                                          this.state.props.data.dataEntryStock
                                            ?.stockDataEntryInWards,
                                          this.state.props.data.jangad,
                                          "pieces"
                                        );
                                      }
                                    })()}
                                    onWheel={e => e.target.blur()}
                                    name="pieces"
                                    placeholder="2001"
                                  />
                                  <ErrorMessage
                                    name="pieces"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="weight"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Total Weight")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.weight && touched.weight
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.data ? true : false
                                    }
                                    value={(() => {
                                      if (this.state.props.isEdit == 1) {
                                        return this.state.props.data.weight;
                                      } else {
                                        return ShowDiffenence(
                                          this.state.props.data.dataEntryStock
                                            ?.stockDataEntryInWards,
                                          this.state.props.data.jangad,
                                          "weight"
                                        );
                                      }
                                    })()}
                                    type="text"
                                    onWheel={e => e.target.blur()}
                                    name="weight"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="weight"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </Row>
                          </CardBody>
                        </div>
                      </div>

                      {this.state.props.isEdit != 1 ? (
                        ""
                      ) : (
                        <div className="row px-3 pt-3">
                          <div className="d-flex justify-content-between">
                            <h3 className="fw-bold pb-3 text-black">
                              {this.props.t("Enter stock Details")}
                            </h3>
                            <button
                              type="button"
                              className="bg-transparent border-0"
                              onClick={() => this.addRow()}
                            >
                              <img
                                src="images/dashboard-images/addRow.svg"
                                alt="add Row"
                              />
                            </button>
                          </div>

                          <div className="table-responsive">
                            <BootstrapTable
                              keyField="id"
                              classes="foo"
                              headerClasses="background-light fs-5"
                              footerClasses="background-light fs-5"
                              defaultSorted={defaultSorted}
                              data={this.state.stockList}
                              columns={this.columns1}
                              cellEdit={cellEditFactory({
                                mode: "click",
                                blurToSave: true,
                                afterSaveCell: () => {
                                  this.setState({
                                    stockList: [...this.state.stockList],
                                  });
                                },
                                // nonEditableRows: () =>
                                //   this.state.notEditableRows,
                              })}
                            />
                            {submitCount > 0 &&
                            this.state.stockList.filter(
                              x => x.weight > 0 && x.pieces > 0
                            ).length == 0 ? (
                              <p className="text-danger">
                                Enter minimum one record
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )}

                      <div className="row px-3 pt-4">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                            {this.props.t("Stock summary")}
                          </h3>
                        </div>

                        <div className="table-responsive">
                          <BootstrapTable
                            classes="foo"
                            keyField="id"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.state.stockList}
                            columns={this.columns1}
                          />
                        </div>
                      </div>

                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="stockDataEntryInWards"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            {this.props.t("Self Internal Remarks")}
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.remarks && touched.remarks
                                ? " is-invalid"
                                : "")
                            }
                            readOnly={true}
                            type="text"
                            name="remarks"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="remarks"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="nextRemarks"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            {this.props.t("For Next Person Remarks")}
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.nextRemarks && touched.nextRemarks
                                ? " is-invalid"
                                : "")
                            }
                            disabled={
                              this.state.props.isEdit == 3 ? true : false
                            }
                            type="text"
                            name="nextRemarks"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="nextRemarks"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>

                      {this.state.props.isEdit == 3 ? (
                        <div className="col-md-12 text-center text-md-end pe-3 py-5">
                          <Button
                            color="primary"
                            className="fs-4 px-5"
                            type="submit"
                            onClick={() => this.state.history.goBack()}
                          >
                            Back
                          </Button>
                        </div>
                      ) : (
                        <div className="col-md-12 text-center text-md-end pe-3 py-5">
                          <Button
                            color="primary"
                            className="fs-4 px-5"
                            type="submit"
                            onClick={() => {
                              validateForm()
                                .then(data => {
                                  if (Object.keys(data).length == 0) {
                                    this.assign(values);
                                  }
                                })
                                .catch(err => console.log(err));
                            }}
                          >
                            Assign
                          </Button>
                        </div>
                      )}
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(UserOutwardStock);
